module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/paypal-4a2d0e658550ae718633e2497afb6173.svg";